export const selectSymbolMap = (state) => {
    return state.get('symbolMap').toJS()
}